import type { ParseOptions } from '@noths/polaris-product-listings-urls';
import { createSelector } from '@reduxjs/toolkit';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { shopSurfaceBasePath } from 'src/utils/shopSurfaceBasePath';

/**
 * The {@link ParseOptions} for the current taxonomy-shop route — the surface base
 * path (`/shop/all`, `/shop/gifts`) plus the ordered taxonomy aliases — used to
 * canonicalise and match URLs in this neighbourhood. `null` off the taxonomy
 * route (no surface), where there is no map to match against anyway. Memoised so
 * it is a stable reference while the route is unchanged.
 */
export const selectRouteParseOptions = createSelector(
  [
    (state: ReduxApplicationState) => state.productsQuery.surface,
    (state: ReduxApplicationState) => state.productsQuery.taxonomyAttributeAliases,
  ],
  (surface, taxonomyAttributeAliases = []): ParseOptions | null => {
    const basePath = shopSurfaceBasePath(surface);

    return basePath ? { basePath, taxonomyAliases: taxonomyAttributeAliases } : null;
  },
);
